module.exports = __webpack_public_path__ + "img/share-btn-left.1bd04398.png";